export default __webpack_public_path__ + "static/media/bg.e54d872c.svg";